import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type NotifyWriteRequestData = {
    line_uid: string,
    login: string,
    // LINE-已受理
    line_accepted: boolean,
    // Mail-已受理
    mail_accepted: boolean,
    // LINE-已取件
    line_picked_up: boolean,
    // Mail-已取件
    mail_picked_up: boolean,
    // LINE-維修中
    line_under_repair: boolean,
    // Mail-維修中
    mail_under_repair: boolean,
    // LINE-已完修
    line_repair_done: boolean,
    // Mail-已完修
    mail_repair_done: boolean,
    // LINE-已出貨
    line_shipped: boolean,
    // Mail-已出貨
    mail_shipped: boolean,
};

function notifyWrite(data: NotifyWriteRequestData): Promise<DefaultResponseData> {
    return fetchData('api/notify_write', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { notifyWrite };
